<template>
    <div class="content-container">
        <div class="table-wrapper">
            <!-- 上部分 -->
            <div class="top-box">
                <!-- 切換團隊個人專案和團隊專案 -->
                <div class="tabs" v-if="isTeam">
                    <a-radio-group v-model="teamType" button-style="solid" @change="changeTeamType">
                        <a-radio-button :value="1">
                            {{$t('table.project.type.0')}}
                        </a-radio-button>
                        <a-radio-button :value="2">
                            {{$t('table.project.type.1')}}
                        </a-radio-button>
                    </a-radio-group>
                </div>
                <!-- 搜索 -->
                <div class="search-box">
                    <div class="list">
                        <label>{{$t('table.project.thead.name')+'：'}}</label>
                        <a-input v-model="searchForm.name" :placeholder="$t('form.project.name.placeholder')"/>
                    </div>
                    <div class="btns">
                        <a-button type="primary" @click="searchEvent">{{ $t(`actionTitles.search`) }}</a-button>
                    </div>
                </div>
            </div>

            <!-- 表格-->
            <a-table
                    :data-source="tableData"
                    :pagination="pagination"
                    :row-key="record => record.id"
                    @change="handleTableChange"
            >
                <a-table-column
                        key="name"
                        :title="$t('table.project.thead.name')"
                        data-index="name"
                />
                <a-table-column
                        key="cover"
                        :title="$t('table.project.thead.cover')"
                        data-index="cover"
                        align="center"
                >
                    <template slot-scope="text, record">
                        <img class="cover-img" :src="record.cover?record.cover:defaultImg"/>
                    </template>
                </a-table-column>
                <a-table-column
                        key="leader"
                        :title="$t('table.project.thead.leader')"
                        data-index="leader"
                        align="center"
                >
                <template slot-scope="text, record">
                    {{record.leader?record.leader: '--'}}
                </template>
                </a-table-column>
                <a-table-column
                        key="phone"
                        :title="$t('table.project.thead.phone')"
                        data-index="phone"
                        align="center"
                >
                    <template slot-scope="text, record">
                        {{record.phone?record.phone: '--'}}
                    </template>
                </a-table-column>
                <a-table-column
                        key="progress_rate_text"
                        :title="$t('table.project.thead.progress')"
                        data-index="progress_rate_text"
                        align="center"
                >
                    <template slot-scope="text, record">
                        {{record.progress_rate_text?record.progress_rate_text: '--'}}
                    </template>
                </a-table-column>
                <a-table-column
                        key="create_time"
                        :title="$t('table.common.thead.createTime')"
                        data-index="create_time"
                        :sorter="true"
                        align="center"
                >
                    <template slot-scope="text, record">
                        {{ record.create_time ? record.create_time : "--" }}
                    </template>
                </a-table-column>

                <a-table-column
                        key="operate"
                        :title="$t('table.common.thead.operate')"
                        align="center"
                >
                    <template slot-scope="text, record">
                        <a :href="'https://qwhouse720.com/qwj/projectDetail?id='+record.id" target="_blank" class="operate-link">{{$t('actionTitles.preview')}}</a>
                    </template>
                </a-table-column>
            </a-table>
        </div>
    </div>
</template>

<script>
    import {getProjectList} from "@/api/project"
    import {mapState} from "vuex";
    export default {
        name: "List",
        data(){
            return{
                defaultImg: require('@/assets/img/default_list.jpg'),
                tableData: [],
                searchForm: {
                    name: "",
                    order: [],
                },
                pagination: {
                    showQuickJumper: true,
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                loading: false,
                searchParam: {
                    type: 1,
                    current_page: 1,
                    per_page: 10
                },
                isTeam: 0,//是否是團隊帳號 0為個人，1為團隊帳號
                teamType: 1,//查看團隊個人還是團隊總專案 1為個人 2為團隊
            }
        },
        computed:{
            ...mapState({
                userInfo: (state) => state.user.userInfo,
            }),
        },
        mounted() {
            this.isTeam = parseInt(this.userInfo.team_id)
            this.getList()
        },
        methods:{
            //獲取列表
            getList(){
                this.loading = true;
                this.searchParam ={
                    ...this.searchParam,
                    ...this.searchForm,
                    type: this.isTeam ? this.teamType : 1,
                    current_page: this.pagination.current,
                    per_page: this.pagination.pageSize
                }
                getProjectList(this.searchParam)
                    .then((res) => {
                        this.loading = false;
                        this.tableData = res.data.data
                        this.pagination.total = res.data.total
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            //table 翻頁
            handleTableChange(pagination, filters, sorter) {
                this.pagination = pagination;
                if (Object.keys(sorter).length > 0) {
                    let field = sorter.field;
                    let orderStr = sorter.order == "ascend" ? "asc" : "desc";

                    let order = {};
                    order[field] = orderStr;
                    this.searchForm.order = order;
                }
                this.getList();
            },
            //切換個人、團隊總專案
            changeTeamType(e){
                this.teamType = e.target.value
                this.pagination.current = 1
                this.getList()
            },
            //搜索
            searchEvent(){
                this.pagination.current = 1
                this.getList()
            }
        }
    }
</script>

<style lang="less" scoped>
    .cover-img{
        width: 100px;
        height: 53px;
        object-fit: cover;
    }
    .operate-link{
        color: #0d95e8;
        cursor: pointer;
    }
    .top-box{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .search-box{
            display: flex;
            align-items: center;
            .list{
                display: flex;
                align-items: center;
                label{
                    flex-shrink: 0;
                    margin-right: 5px;
                }
            }
            .btns{
                display: flex;
                align-items: center;
                .ant-btn{
                    margin-left: 10px;
                }
                .searchBtn {
                    background-color: #7101ad;
                    border-color: #7101ad;
                }
            }
        }

        .tabs{
            display: flex;
            align-items: center;
            flex-shrink: 0;
            margin-right: 20px;
            .type-btn{
                margin-right: 10px;
            }
        }
    }
</style>